/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { colors, mixins } from '@blend/consumer-components';
import Documents from '../Documents/Documents';
import { DocumentsAPI } from '../../../api/common/documents';
import SigningDocument from '../../common/Documents/SigningDocument';
import { Scrollable } from '../../../components/Scrollable/Scrollable';
import { SidebarContent } from './SidebarContent';

const styles = StyleSheet.create({
  wrapper: {
    width: 274,
    height: '100%',
    display: 'flex',
    boxShadow: mixins.boxShadow(0, 4, 4, 0, mixins.fade(colors.black, 0.25)),
    overflowY: 'auto',
  },
});

export namespace Sidebar {
  export interface Props {
    ownerId: string;
    documents: DocumentsAPI.DocumentsResponse | null;
    setDocuments: (docs: DocumentsAPI.DocumentsResponse) => void;
    fetchDocuments: () => void;
    onSelectDocument: (doc: SigningDocument) => void;
    setIsUploaderOpen: (show: boolean) => void;
  }
}

export const Sidebar: React.FC<Sidebar.Props> = ({
  ownerId,
  documents,
  setDocuments,
  fetchDocuments,
  onSelectDocument,
  setIsUploaderOpen,
}) => {
  return (
    <div className={css(styles.wrapper)} data-it="Sidebar">
      <SidebarContent title="Documents">
        <Scrollable>
          <Documents
            ownerId={ownerId}
            documents={documents}
            setDocuments={setDocuments}
            fetchDocuments={fetchDocuments}
            onSelectDocument={onSelectDocument}
            setIsUploaderOpen={setIsUploaderOpen}
          />
        </Scrollable>
      </SidebarContent>
    </div>
  );
};
